//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import cmBlank from '@/components/cmBlank.vue'
import cmLoadmore from '@/components/cmLoadmore.vue'
import wx from 'weixin-js-sdk'; 

export default {
  components: {
      cmBlank,cmLoadmore, wx
  },
  data () {
    return {
      blankShow:false,
      loadStatus:false,
      popUp:false,
      loadmoreText:'正在加载。。。',
      busy:false,
      pageFlag:2,
      hasNext:0,
      lastId:0,
      list:[],
      info:{},
      qrcode:'',
      qrcodeTitle:'',
      qrcodeShow:false,
      showMoreIndex:-1,
      index:'',
      lightType:'',
      number:'30',
      strip_code:'',
    }
  },
  created(){
    this.config();
  },
  mounted(){
    this.code = '';
  },
  methods:{
    copy(val){
        this.$func.copy(val,event);
    },
    clickType(i){
        this.formData.type = i;
    },  
    add(id){
        this.$router.push({name:'deviceEdit',params:{id:id}})
    },
    setting(id){
        this.$router.push({name:'deviceSetting',params:{id:id}})
    },
    airPair(id){
        this.$router.push({name:'airPair',params:{id:id}})
    },
    search(){
        this.list = [];
        this.lastId = 0;
        this.hasNext = 0;
        this.loadmore();
    },
    resetSearch(){
        this.code = '';
        this.list = [];
        this.lastId = 0;
        this.hasNext = 0;
        this.loadmore();
    },
    searchSubmit(){
      this.lastId = 0;
      this.pageFlag = 2;
      this.list = [];
      this.loadmore();
    },
    getList(){
        this.$api.getDeviceList({last_id:this.lastId,page_flag:this.pageFlag,code:this.code}).then((res)=>{
            if(res){
                if(!this.lastId){
                    this.blankShow = res.data.length > 0 ? false : true;
                }
                this.hasNext = res.hasNext;
                this.lastId = res.lastId;
                res.data.forEach((item)=>{
                    this.list.push(item);
                });
            }
        }) 
    },
    operate(index,state){
        this.$func.startLoading('请求中。。。');
        let id = this.list[index].id;
        let type = this.list[index].type;
        this.$api.deviceOperate({id:id,state:state}).then((res)=>{
            if(res.code === 0){
                if(type == 3 || type == 4){
                    this.list[index].state = state;
                }
                this.$func.showToast('操作成功');
            }
            this.$func.endLoading();
        }) 
    },
    changeStatus(index,status){
        let text = status ? '确认开启该设备？' : '确认关闭该设备？';
        this.$func.confirm(text,'提示',()=>{
            this.$func.startLoading('请求中。。。');
            let id = this.list[index].id;
            this.$api.changeDeviceStatus({id:id,status:status}).then((res)=>{
                if(res.code === 0){
                    this.list[index].status = status;
                    if(status && this.list[index].type == 5){
                        this.list[index].on_line = 1;
                    }else if(!status){
                        this.list[index].on_line = 0;
                    }
                    this.$func.showToast('操作成功');
                }
                this.$func.endLoading();
            })
        })
    },
    
   lightUp(index,type){
    this.index = index;
    this.lightType = type;
    this.popUp = true;
   },
   submitLight(){
        this.$func.startLoading('请求中。。。');
        let id = this.list[this.index].id;
        this.$api.operateLightUp({id:id,strip_code:this.strip_code,number:this.number,type:this.lightType}).then((res)=>{
            if(res.code === 0){
                this.$func.showToast('操作成功');
            }
            this.$func.endLoading();
        }) 
    },
    scanQRCode(){
        let that = this;
        wx.ready(()=> {
            wx.scanQRCode({ 
            needResult: 1,
            scanType: ['barCode'],
            success: function (res) {
                setTimeout(()=>{
                    if(res.resultStr.indexOf(",") != -1){
                        that.strip_code = that.$func.parseScanResult(res.resultStr);
                    }else{
                        that.strip_code = that.$func.parseScanResult(res.resultStr);
                    }
                },300);
            }
            })
        });
        wx.error((res)=> {
            console.log(res)
            // alert(res.errMsg);
        })
    },  
    delDevice(id){
         this.$func.confirm('确认删除？','提示',()=>{
            this.$api.delDevice({id:id}).then((res)=>{
                if(res){
                    this.resetSearch();
                }
            }) 
         })
    },  
    qrcodeDevice(id,type){
        this.$func.startLoading('请求中。。。');
        this.$api.qrcodeDevice({id:id,type:type}).then((res)=>{
            if(res){
                this.$func.endLoading();
                this.qrcode = res.data.qrcode;
                this.qrcodeTitle = type ? '取衣码' : '开锁码';
                this.qrcodeShow = true;
            }
        }) 
    },  
    toggleMore(index){
        if(this.showMoreIndex == index){
            this.showMoreIndex = -1;
        }else{
            this.showMoreIndex = index;
        }
    },
    config(){
        let url = (window.location.href).split('#');
        if(url[0].indexOf('?') != '-1'){
            url = url[0].split('?');
        }
        this.$api.wxSign({url:url[0]}).then((res)=>{
            if(res){
                wx.config({
                    debug: false, 
                    appId: res.data.appId,
                    timestamp: res.data.timestamp,
                    nonceStr: res.data.nonceStr,
                    signature:res.data.signature,
                    jsApiList: [
                        "scanQRCode"
                    ]
                });
            }
        })
    },
    loadmore(){
        if(this.lastId > 0 && !this.hasNext){
            this.busy = true;
            this.loadStatus = true;
            this.loadmoreText = '没有更多了。。。'
            return ;
        }
        this.busy = true;
        this.loadStatus = true;
        this.loadmoreText = '正在加载。。。';
        this.getList();
        setTimeout(()=>{
           if(this.blankShow){
                this.busy = true;
                this.loadStatus = false;
                this.loadmoreText = '没有更多了。。。'
            }else{
                if(this.hasNext > 0){
                    this.loadStatus = false;
                    this.busy = false;
                }else{
                    this.busy = true;
                    this.loadStatus = true;
                    this.loadmoreText = '没有更多了。。。'
                }
            }
        },1500)
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/device.vue